import type { StudentResponseEntity } from '@/domains/students/student.entity';

export interface RiskCounters {
  [riskType: string]: number;
}

/**
 * Use Case para agregar contadores de indicadores de riesgo
 * Cumple SRP: Solo cuenta y agrega indicadores de riesgo
 * Similar a ProcessRiskIndicatorsUseCase de centerLayer
 *
 * Responsabilidades:
 * - Contar ocurrencias de cada tipo de riesgo
 * - Agregar indicadores de múltiples estudiantes
 * - Proveer acceso seguro a contadores
 *
 * Extrae lógica que estaba en useRiskCounter.hook.ts
 */
export class AggregateStudentRiskCountersUseCase {
  /**
   * Ejecuta la agregación de contadores de riesgo
   * @param students - Lista de estudiantes a analizar
   * @returns Objeto con contadores por tipo de riesgo
   */
  execute(students: StudentResponseEntity[]): RiskCounters {
    const counters: Record<string, number> = {};

    for (const student of students) {
      for (const risk of student.risk_indicators) {
        counters[risk] = (counters[risk] || 0) + 1;
      }
    }

    return counters;
  }

  /**
   * Obtiene el conteo para un tipo de riesgo específico
   * Método helper para acceso seguro con valor por defecto
   * @param counters - Objeto de contadores generado por execute()
   * @param riskType - Tipo de riesgo a consultar
   * @returns Número de ocurrencias (0 si no existe)
   */
  getCountForRisk(counters: RiskCounters, riskType: string): number {
    return counters[riskType] || 0;
  }
}
